export default "__VITE_ASSET__Bc7c2KD6__"